// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Laa-z","narrowOptionButtons":"Maa-z","noOptions":"Naa-z"};